import { type ApiConfig } from "../../types/api";

export class CacheManager {
  private cache: Map<string, { data: any; timestamp: number }> = new Map();
  private config: ApiConfig;

  constructor(config: ApiConfig) {
    this.config = config;
  }

  public getCacheKey(url: string, params?: any): string {
    const paramString = params ? JSON.stringify(params) : "";
    return `${url}${paramString}`;
  }

  public getFromCache<T>(key: string): T | null {
    if (!this.config.enableCache) return null;

    const cached = this.cache.get(key);
    if (!cached) return null;

    const isExpired = Date.now() - cached.timestamp > this.config.cacheTimeout;
    if (isExpired) {
      this.cache.delete(key);
      return null;
    }

    return cached.data;
  }

  public setCache<T>(key: string, data: T): void {
    if (!this.config.enableCache) return;

    this.cache.set(key, {
      data,
      timestamp: Date.now(),
    });
  }

  public clearCache(): void {
    this.cache.clear();
  }

  public deleteCacheEntry(key: string): void {
    this.cache.delete(key);
  }

  public getCacheSize(): number {
    return this.cache.size;
  }

  public cleanupExpiredCache(): void {
    const now = Date.now();
    for (const [key, entry] of this.cache.entries()) {
      if (now - entry.timestamp > this.config.cacheTimeout) {
        this.cache.delete(key);
      }
    }
  }
}
